var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._b({attrs:{"type":_vm.type,"border":"left","text":"","icon":"mdi-alert-circle-outline"}},'v-alert',_vm.$attrs,false),[_c('ressource',{staticClass:"black--text",attrs:{"code":_vm.code,"hide-if-empty":_vm.hideIfEmpty}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }